import { TrackingConfigPreset } from '@poseidon/tracklib';
import { appConfig, userData } from '../config';

export const trackingConfig: TrackingConfigPreset = {
  lib: {
    properties: {
      lib: {
        stage: appConfig.core.isProd ? /* istanbul ignore next if */ 'live' : 'qa'
      },
    },
    parameter: {
      software: 'navigator',
      softwareversion: appConfig.appVersion,
      environment: 'nav',
      brand: appConfig.core.brand,
      product: userData.userlevel,
      profileblocked: userData.profileblocked,
      hid: userData.hashedUasAccountId,
      registrationcountry: /* istanbul ignore next else */ userData.country ? userData.country.toLowerCase() : undefined,
    },
  },
};
